var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#001E50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 .632C10.676.632.633 11.5.633 24.918H3.2C3.2 12.937 12.075 3.2 23 3.2c10.925 0 19.8 9.736 19.8 21.716h2.568C45.367 11.5 35.323.632 23 .632z",
    transform: "translate(0 9.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.583 13.417l-8.74 8.72c-.274-.074-.559-.107-.843-.095-1.588 0-2.875 1.287-2.875 2.875 0 1.587 1.287 2.875 2.875 2.875s2.875-1.288 2.875-2.875c-.001-.307-.053-.611-.153-.901l8.778-8.683-1.917-1.916z",
    transform: "translate(0 9.583)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.8b7560e2bf60c18ccd61cedfaf6723ec.svg";
export { ForwardRef as ReactComponent };